import { http, delay as mswDelay, HttpResponse } from 'msw'

import { UserSettingApiModelStub } from '@webapp/platform/iam/data-access/api-models/stubs/UserSettingApiModel.stub'
import { type UserSettingApiModel } from '@webapp/platform/iam/data-access/api-models/UserSettingApiModel'
import { getResponseObject } from '@webapp/tests/getResponseObject'

// `delayMs` lets a test defer this query so a sibling query (e.g. the user
// details request that drives `user.fullName`) settles first. Defaults to 0 so
// existing consumers keep their current timing.
export const mockGetUserThresholdSettingsSuccess = (
  userId: number,
  data: UserSettingApiModel = UserSettingApiModelStub.build(),
  delayMs = 0
) => {
  return http.get(
    `/api/v2/user/${userId}/setting`,
    async () => {
      await mswDelay(delayMs)

      return HttpResponse.json(getResponseObject(data), { status: 200 })
    },
    { once: true }
  )
}
